var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-districtofficeblock__wrapper" }, [
    _c("div", { staticClass: "c-districtofficeblock__inner" }, [
      _c(
        "div",
        { staticClass: "c-districtofficeblock--icon" },
        [_c("v-icon", { attrs: { name: _vm.icon, size: "lg" } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-districtofficeblock__inner--information" }, [
        _c("div", { staticClass: "c-districtofficeblock__name" }, [
          _vm._v(_vm._s(_vm.name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-districtofficeblock__adress" }, [
          _vm._v(_vm._s(_vm.adress))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-districtofficeblock__link" }, [
          _c("a", { attrs: { href: _vm.url } }, [
            _vm._v("Se kontorets öppettider")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }